export let FulfillmentMethodType = /*#__PURE__*/function (FulfillmentMethodType) {
  FulfillmentMethodType["DELIVERY"] = "DELIVERY";
  FulfillmentMethodType["PICKUP"] = "PICKUP";
  return FulfillmentMethodType;
}({});
export let DeliveryAreaType = /*#__PURE__*/function (DeliveryAreaType) {
  DeliveryAreaType["CUSTOM"] = "CUSTOM";
  DeliveryAreaType["RADIUS"] = "RADIUS";
  DeliveryAreaType["POSTAL_CODE"] = "POSTAL_CODE";
  DeliveryAreaType["PROVIDER_DEFINED"] = "PROVIDER_DEFINED";
  return DeliveryAreaType;
}({});
export let RadiusUnit = /*#__PURE__*/function (RadiusUnit) {
  RadiusUnit["KILOMETERS"] = "KILOMETERS";
  RadiusUnit["MILES"] = "MILES";
  return RadiusUnit;
}({});
//# sourceMappingURL=fulfillment.js.map